<template>
  <div :class="workingClass">
    <i class="material-icons" style="float:left;">{{icon}}</i>
    <span style="float:right;" v-if="!isMobileDevice()">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: "s-label",

  computed: {
    workingClass() {
      var c = "label-cell ";
      c += this.type ? this.type + " " : "";
      c += this.size ? this.size + " " : "";
      return c;
    }
  },
  props: {
    right: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default: null
    },

    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: null
    }
  }
};
</script>
<style scoped>

.label-cell {
  display: flex;
  /* justify-content: center; */
  /* align-self: center;    <---- REMOVE */
  align-items: center;
  /* color: #ffffff; */

}

.label-cell.warning {
  background-color: #e6a23c;
  color: #ffffff;

}
.label-cell.danger {
  background-color: #f56c6c;

  color: #ffffff;
}
.label-cell.success {
  background-color: #67c23a;

  color: #ffffff;
}
.label-cell.primary {
  background-color: #409eff;


  color: #ffffff;
}


/* round{
   
} */
</style>
